import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";

export default {
    getReportData,
    getDivisionsForDropDown,
    getJobsForDropdown
};

async function getOperationEntitiesByGroupForDropDown(id) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetAllEstates', null);
    for (let item of Object.entries(response.data)) {
        if (item[1]["groupID"] === parseInt(id) && item[1]["isActive"] === true)
            operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
    return operationEntityArray;
}

async function getDivisionsForDropDown(id) {
    var divisionArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllDivisionsByEstateID', 'estateID=' + id);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            divisionArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return divisionArray;
}

async function getJobsForDropdown() {
    var jobArray = [];
    const response = await CommonGet('/api/TappingCheckListReport/GetAllRubberJobTypes', null)
    for (let item of Object.entries(response.data)) {
        jobArray[item[1]["rubberJobTypeID"]] = item[1]["rubberJobTypeName"]
    }
    return jobArray;
}

async function getReportData(model) {
    const response = await CommonPost('/api/TappingCheckListReport/GetTappingCheckListReportDetails', null, model);
    return response.data;
}
